import { createContext } from 'react';

import { Holiday } from 'types/models/Holiday';

export type HolidaysContextType = {
  holidays: Holiday[];
};

export const HolidaysContext = createContext<HolidaysContextType>({ holidays: [] });
